webpackJsonp([131680063598450],{

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Production Build'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section describes the process of creating a development build of your project.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'The Command'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you open up the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'package.json'
	      ),
	      ' file you\'ll see a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'build:production'
	      ),
	      ' script that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      "scripts": {\n        "build:production": "npm run clean && webpack --env.webpack=production --env.lore=production -p",\n      },\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This script is used when you want to create a production build of your project.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Creating the Build'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Run this command to create a development build of your project:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      npm run build:production\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You should see output similar to this once it completes, which took 49 seconds for this example:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      Build completed in 49.237s\n\n      Hash: e26aa54c61ee42b36fef\n      Version: webpack 2.4.1\n      Time: 49241ms\n                                                              Asset       Size  Chunks                    Chunk Names\n                              bundle.vendor.760c1aca95f06ca49cc5.js     197 kB       1  [emitted]         vendor\n        favicons-226798db74552f749c8ab26e8bfae037/favicon-16x16.png  644 bytes          [emitted]\n      favicons-226798db74552f749c8ab26e8bfae037/favicon-230x230.png      17 kB          [emitted]\n        favicons-226798db74552f749c8ab26e8bfae037/favicon-96x96.png    5.87 kB          [emitted]\n              favicons-226798db74552f749c8ab26e8bfae037/favicon.ico    33.3 kB          [emitted]\n                   favicons-226798db74552f749c8ab26e8bfae037/.cache  996 bytes          [emitted]\n                                              favicon-manifest.json  877 bytes          [emitted]\n                                bundle.main.11e83aeeb2a9a9714d66.js    1.41 MB       0  [emitted]  [big]  main\n        favicons-226798db74552f749c8ab26e8bfae037/favicon-32x32.png    1.58 kB          [emitted]\n                               styles.main.11e83aeeb2a9a9714d66.css    1.15 kB       0  [emitted]         main\n                            bundle.main.11e83aeeb2a9a9714d66.js.map    12.4 MB       0  [emitted]         main\n                           styles.main.11e83aeeb2a9a9714d66.css.map  113 bytes       0  [emitted]         main\n                          bundle.vendor.760c1aca95f06ca49cc5.js.map     2.1 MB       1  [emitted]         vendor\n                                                asset-manifest.json  472 bytes          [emitted]\n                                          assets/images/favicon.png     266 kB          [emitted]  [big]\n                                             assets/images/logo.png    27.7 kB          [emitted]\n                                                         index.html    5.27 kB          [emitted]\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What does it do?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Running this command will compile your project and place all the assets in a new folder named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/dist'
	      ),
	      ' at the root of your project.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This process will do everything the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/webpack/building/development/' },
	        'development build'
	      ),
	      ' does, but will also:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Minify and uglify all assets, to reduce their file sizes.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The minification and ugliciation process can take a significant amount of time to complete depending on the size of your project, which is why the development build exists. But otherwise the process and generated files are identical.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-building-production-js-0a7999ef164e21e1955c.js